import { render, staticRenderFns } from "./TermLink.vue?vue&type=template&id=5b5df344&scoped=true&"
import script from "./TermLink.vue?vue&type=script&lang=js&"
export * from "./TermLink.vue?vue&type=script&lang=js&"
import style0 from "./TermLink.vue?vue&type=style&index=0&id=5b5df344&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5df344",
  null
  
)

export default component.exports